// TODO(Rebrand): Migrate this to orbit's Select when implementing dark mode for Insights
import { Select } from '@apollo/space-kit/Select';
import React from 'react';
import { SelectChangeEvent } from 'typings/events/selection-change-event';

import { DateRangeBadge } from 'src/components/dateRangeBadge/DateRangeBadge';

import { SubscriptionRegistrationInfoIcon } from './SubscriptionRegistrationInfoIcon';
import { OperationMetricType } from './types';

interface RequestsOverTimeHeadingProps {
  operationMetricType: string;
  onOperationMetricTypeChange: (
    event: SelectChangeEvent<OperationMetricType>,
  ) => void;
  isSubscriptionOperation: boolean;
}

export const RequestsOverTimeHeading = ({
  operationMetricType,
  onOperationMetricTypeChange,
  isSubscriptionOperation,
}: RequestsOverTimeHeadingProps) => {
  return (
    <>
      <Select
        value={operationMetricType}
        onChange={onOperationMetricTypeChange}
        feel="flat"
        className="font-heading text-xl font-medium text-heading"
        placement="bottom-start"
      >
        <option className="font-normal" value="requestRate">
          {isSubscriptionOperation
            ? 'Subscription registration rate'
            : 'Request Rate'}
        </option>
        <option className="font-normal" value="requests">
          {isSubscriptionOperation ? 'Subscription registrations' : 'Requests'}
        </option>
      </Select>
      {isSubscriptionOperation && <SubscriptionRegistrationInfoIcon />}
      <DateRangeBadge />
    </>
  );
};
